import React from 'react';
import { connect } from 'react-redux'
import {
  feeds_archive,
  destroy_feed,
  restore_feed
} from '../actions'
import { Link, Redirect } from 'react-router-dom'
import Pagination from './Pagination'
import Loading from './Loading';
import {
  is_logged_on,
  is_validating
 } from "../helpers"

const mapStateToProps = state => {
  return {
    feed: state.feed
  };
};

const mapDispatchToProps = dispatch => {
    return {
      getFeeds: (page) => dispatch ( feeds_archive(page) ),
      destroyFeed: (id, page) => dispatch ( destroy_feed(id, page) ),
      restoreFeed: (feed_id, page) => dispatch ( restore_feed(feed_id, page) ),
    }
}

class ConnectedArchives extends React.Component {
  constructor () {
    super()
    this.state = {
      clickedId: ''
    }
  }

  setCurrent(id) {
    this.setState({clickedId: id})
  }

  resetCurrent() {
    this.setState({clickedId: ''})
  }

  destroyFeed(feed_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.feed.pagination
    this.props.destroyFeed(feed_id, page)
  }


  restoreFeed(feed_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.feed.pagination
    this.props.restoreFeed(feed_id, page)
  }

  componentDidMount() {
    this.props.getFeeds(1)
  }

  render() {
    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/login" />
    }

    const feeds = this.props.feed.items;
    const { fetching, pagination } = this.props.feed;

    if (fetching) {
      return (
       <Loading />
      )
    }

    return (
      <div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Archived Projects</span>
					<i className="material-icons right">delete</i>
				</div>
				<table className="bordered striped highlight responsive-table">
					<thead>
						<tr>
							<th>Project Name</th>
							<th>Date Archived</th>
              {
                // <th>User</th>
              }
							<th>Details</th>
              {
                // <th>Status</th>
              }
							<th>Actions</th>
						</tr>
					</thead>
				 	<tbody>
						{feeds.map(function(feed){
							const {id, name, deleted_at, draft, optimizations, published} = feed;
              const current = this.state.clickedId

              let links
              if (feed.id !== current) {
                links = (
                  <div className="meta" onMouseLeave={(e) => {
                    this.resetCurrent()
                  }}>
                    <Link className="c-darkgrey" to={`/projects/${feed.id}`}>View</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.setCurrent(feed.id)
                      }}
                      >Permanently Delete</Link>
                  </div>
                )
              } else {
                links = (
                  <div className="meta">
                    <Link className="c-darkgrey" to="#" onClick={(e)=>{
                      e.preventDefault()
                      this.resetCurrent()
                    }}>Cancel</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.destroyFeed(feed.id)
                      }}
                      >Are you sure?</Link>
                  </div>
                )
              }

							return (
								<tr key={id}>
									<td>
										<Link className="view" to={`/projects/${feed.id}`}>{name}</Link>
                    { links }
									</td>
									<td>{new Date(deleted_at).toLocaleDateString()}, {new Date(deleted_at).toLocaleTimeString()}</td>
                  {
                    // <td>user here</td>
                  }
									<td>
										<small><p>{optimizations} Optimized Feeds</p></small>
										<small><p>{published} Published</p></small>
										<small><p>{draft} Draft</p></small>
									</td>
                  {
                    // <td>
                    //   <i className="material-icons c-grey">restore</i>
                    // </td>
                  }
									<td>
										<button className="btn red darken-1 waves-effect waves-light" onClick={(e)=>{
                      e.preventDefault()
                      this.restoreFeed(feed.id)
                    }}>RESTORE</button>
									</td>
								</tr>
							)
						}, this)}
			 		</tbody>
				</table>
        <Pagination pagination={pagination} fetchPage={this.props.getFeeds}/>
      </div>
    )
  }

}

const Archives = connect(mapStateToProps, mapDispatchToProps)(ConnectedArchives);

export default Archives;



// WEBPACK FOOTER //
// ./src/js/components/Archives.js